import { useOutletContext } from "react-router-dom";
import EventEmitter from "../../utils/eventEmitter";
import Axios from "../utils/axios"


export const loadPurchaseOrders = async () => {
  try {
    const response = await Axios.get('purchase-orders');
    const responseData = await response.data;
    return responseData;
    // return []
  }catch (err) {
    throw err;
  }
};

export const loadQuotations = async () => {
  try {
    const response = await Axios.get('purchase-orders/rfqs');
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};

const loadOneQuotation = async (name) => {
  try {
    const respnse = await Axios.get('purchase-orders/'+name);
    const responseData = await respnse.data;
    return responseData;
  }catch (err) {
    throw err;
  }
}

export const loadPOTransfer = async (number, document) => {
  try {
    const filter = encodeURI(JSON.stringify({number: number, document: document}));
    const respnse = await Axios.get('purchase-orders/transfer/'+filter);
    const responseData = await respnse.data;
    return responseData;
  }catch (err) {
    throw err;
  }
}

export const loadPOTransfers = async (action) => {
  try {
    const respnse = await Axios.get('purchase-orders/transfers/all/'+action);
    const responseData = await respnse.data;
    return responseData;
  }catch (err) {
    throw err;
  }
}


export const loadProchaseOrder = async (action) => {
  try {
    switch (action) {
      case 'new':
        const response = await Axios.get('setups/purchaseorders');
        const responseData = await response.data;
        return {...responseData, purchaseOrder: {}};
        // return {taxes: [], products: [], contacts:[], operationTypes:[], quotation:{}};
        
      default:
        const data = await loadOneQuotation(action);
        return data;
    }
  }catch (err) {
    throw err;
  }
}

const usePurchaseOrderAPI = () => {
  const { success, error } = useOutletContext();


  const create = async (data) => {
    try {
      const respnse = await Axios.post('purchase-orders', data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('purchase_rfq_created', responseData.number);
    }catch(err) {
      console.log(err);
    }
  }

  const update = async (seo, data) => {
    try {
      const respnse = await Axios.put('purchase-orders/'+seo, data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('purchase_rfq_created', data.seo);
    }catch (err) {
      throw err;
    }
  }

  const confirm = async (number, data) => {
    try {
      const respnse = await Axios.patch('purchase-orders/'+number.replaceAll('/', '-'), data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('purchase_order_confirmed', number);
    }catch (err) {
      if (err.code === 'ERR_NETWORK') {
        error("Couldn't process request. Please check your network connectivity");
      }else {
        console.log(err)
        error(err.response.data.message);
      }
      throw err;
    }
  }

  const validate = async (data) => {
    try {
      const respnse = await Axios.put('purchase-orders/validate/transfer', data);
      const responseData = await respnse.data;
      success(responseData.message);
      // EventEmitter.dispatch('purchase_rfq_created', data.seo);
    }catch (err) {
      throw err;
    }
  }

  return { create, update, confirm, validate };
};



export default usePurchaseOrderAPI;


